import User from "../../apis/User";
import Tags from "../../apis/Tags";

const state = {
    tags: [],
    tagsError: false
};

const actions = {
    showTags({ commit }, id = "") {
        return new Promise((resolve, reject) => {
            Tags.show(id)
                .then((response) => {
                    resolve(response);
                    commit("GET_TAGS", response.data.data);
                })
                .catch((error) => {
                    reject(error);
                    //if (error.response) {
                    commit("DETECT_TAGS_ERROR", error);
                    //}
                })
        })
    },
    createTag({ commit }, { name, type }) {
        return new Promise((resolve, reject) => {
            Tags.store(name, type)
                .then((response) => {
                    resolve(response);
                    commit("ADD_TAGS_REST", response.data.data);
                })
                .catch((error) => {
                    reject(error);
                    commit("DETECT_TAGS_ERROR", error);
                })
        })
    },
    removeTag({ commit }, id) {
        return new Promise((resolve, reject) => {
            Tags.remove(id)
                .then((response) => {
                    resolve(response);
                    commit("REMOVE_TAG_REST", id);
                })
                .catch((error) => {
                    reject(error);
                    commit("DETECT_TAGS_ERROR", error);
                })
        })
    },
    updateTag({ commit }, { name, id }) {
        return new Promise((resolve, reject) => {
            Tags.update(name, id)
                .then((response) => {
                    commit("UPDATE_TAG", { name, id });
                    resolve(response.data.data);
                })
                .catch((error) => {
                    commit("DETECT_TAGS_ERROR", error);
                    reject(error);
                })
        })
    },
};

const mutations = {
    GET_TAGS(state, tags) {
        state.tags = tags;
    },

    DELETE_TAG(state, id) {
        let obj = state.tags.findIndex((el) => el.id == id);
        state.tags.splice(obj, 1);
    },

    UPDATE_TAG(state, { name, id }) {
        let index = state.tags.findIndex((el) => el.id == id);
        state.tags[index].name = name;
    },

    ADD_TAGS_REST(state, tag) {
        state.tags.unshift(tag);
    },

    REMOVE_TAG_REST(state, id) {
        let tagIndex = state.tags.findIndex(el => el.id === id);
        state.tags.splice(tagIndex, 1);
    },

    DETECT_TAGS_ERROR(state, error) {
        if (error.response.status == 401 || error.response.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
            })
        } else if (error.data !== undefined) {
            state.tagsError = error.data.message;
        } else if (error.response.status === 404) {
            state.tagsError = error.response.data.data.name[0];
        } else {
            state.tagsError = "Error";
        }

        setTimeout(() => {
            state.errorTag = "";
        }, 3000)
    },
};

export default {
    state,
    actions,
    mutations,
};
